/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Stop Icon component.
 */
export const MaterialStopIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7.3 3L2 8.3V15.8L7.3 21.1H14.8L20.1 15.8V8.3L14.8 3H7.3ZM7.4 7L11 10.6L14.6 7L16 8.40001L12.4 12L16 15.6L14.6 17L11 13.4L7.4 17L6 15.6L9.6 12L6 8.40001' fill={iconColor} />
    </svg>
  );
};

export default MaterialStopIcon;
